<div class="m-portlet__body">
    <div class="m-checkbox-list">
        <label class="m-checkbox m-checkbox--state-brand">
            <input
                [checked]="allSubcontractors?.length === selectedSubconstractors?.length && selectedSubconstractors?.length !== 0"
                (change)="onChangeSelectLocal()"
                type="checkbox"
                i18n="@@0be9fda4-64f5-572b-8256-77fe2cd3b07c"
            />
            Označi vse
            <span></span>
        </label>
        <div *ngFor="let item of allSubcontractorsGroupd | keyvalue | subcGroupOrder">
            <label *ngIf="item?.key !== 'Brez skupine' || item?.key !== 'Neaktivni'" class="m-checkbox m-checkbox--state-brand">
                <input
                    [checked]="allGroupTags[item?.key]"
                    (change)="onChangeSelectLocal(item?.value, $event)"
                    type="checkbox"
                    i18n="@@0be9fda4-64f5-572b-8256-77fe2cd3b07c"
                />
                {{ item?.key }}
                <span></span>
            </label>
            <label *ngFor="let subcontractor of item?.value" class="m-checkbox ml-4">
                <input
                    [checked]="checkIfSelectedSubcontractor(subcontractor)"
                    (change)="changeSubcontractorFilterLocal({ event: $event, value: subcontractor })"
                    type="checkbox"
                    value="{{ subcontractor.id }}"
                />
                <div class="fc-unthemed">
                    <span [style.background]="subcontractor.bgColor" class="m-badge m-badge--dot"></span>
                    {{ subcontractor.name }}
                </div>
                <span></span>
            </label>
        </div>
    </div>
</div>
